export default __webpack_public_path__ + "static/media/material.413e966d.png";